import { all, call, put, race, select, take, takeEvery } from 'redux-saga/effects'
import { SUCCESS, FAILED } from 'crom-api-constants'
import { filterTableRemoveData } from 'gnos-tables'
import _ from 'lodash'

import config from '../../../../../../../../../../../../../config'

import { createFilterTableId } from '../../../../../../../../../../helpers'

import {
    LOAD_REALESTATES_ESTATES_OWNERSHIP_DETAIL_DATA_TABLE,
    DATA_TABLE_REQUEST,
    REMOVE_REALESTATES_ESTATES_OWNERSHIP_DETAIL_DATA_TABLE,
    OPEN_CADASTRE_LINK,
    OPEN_CADASTRE_LINK_REQUEST,
    LOCALE_PREFIX,
} from './constants'

import { loadDataTableRequest, openCadastreLinkRequest } from './actions'
import { blockSaveCustomData } from '../../../../../../../../../../../components/Workspace/components/HocBlock/actions'

import { localeSelector, tokenSelector, customDataSelector } from './selectors'

import ownershipListEstateDetailSaga from './components/EstateDetail/saga'

import { error } from '../../../../../../../../../../../../../services/toastr'

const MODULE_KEY = config.modules.report.key
const BLOCK_KEY = config.modules.report.blocks.estates.key

function* loadDataTable(id, listId, page = 0, rowsPerPage = 10, sorting = []) {
    const token = yield select(tokenSelector, id)
    if (!token) return null

    let customData = yield select(customDataSelector, id)

    yield put(
        blockSaveCustomData(MODULE_KEY, id, BLOCK_KEY, {
            ownershipListDetail: {
                ..._.get(customData, 'ownershipListDetail', {}),
                [listId]: {
                    ..._.get(customData, `ownershipListDetail.${listId}`, {}),
                    isLoading: true,
                },
            },
        })
    )

    const locale = yield select(localeSelector)
    const sortQsParam = _.join(
        _.map(sorting, (sort) => `${sort.id}:${sort.desc ? 'desc' : 'asc'}`),
        ','
    )

    const result = yield all({
        response: race({
            success: take(`${DATA_TABLE_REQUEST(MODULE_KEY, id, BLOCK_KEY, listId)}_${SUCCESS}`),
            failed: take(`${DATA_TABLE_REQUEST(MODULE_KEY, id, BLOCK_KEY, listId)}_${FAILED}`),
        }),
        request: put(
            loadDataTableRequest(MODULE_KEY, id, BLOCK_KEY, listId, {
                lang: locale,
                'sort[]': sortQsParam,
                rows: rowsPerPage,
                page,
                token,
            })
        ),
    })

    const data = _.get(result, 'response.success.payload.response.body', null)
    if (result.response.failed || !data) return null

    customData = yield select(customDataSelector, id)

    yield put(
        blockSaveCustomData(MODULE_KEY, id, BLOCK_KEY, {
            ownershipListDetail: {
                ..._.get(customData, 'ownershipListDetail', {}),
                [listId]: {
                    ..._.get(customData, `ownershipListDetail.${listId}`, {}),
                    isLoading: false,
                    isLoaded: true,
                    table: {
                        data: _.get(data, 'objects', []),
                        pagination: _.get(data, 'query.pagination', {}),
                        sort: {
                            availableColumns: _.get(data, 'query.sort.availableColumns', []),
                            sorted: _.map(_.get(data, 'query.sort.sortedColumns', []), (sort) => ({
                                id: sort.columm,
                                desc: sort.direction === 'desc',
                            })),
                        },
                    },
                },
            },
        })
    )

    return null
}

function* onLoadDataTable(_action) {
    const id = _.get(_action, 'data.id', null)
    const listId = _.get(_action, 'data.listId', null)
    if (!id || !listId) return null

    const page = _.get(_action, 'data.page', 0)
    const rowsPerPage = _.get(_action, 'data.rowsPerPage', 10)
    const sorting = _.get(_action, 'data.sorting', [])

    yield call(loadDataTable, id, listId, page, rowsPerPage, sorting)

    return null
}

function* onRemoveDataTable(_action) {
    const id = _.get(_action, 'data.id', null)
    const listId = _.get(_action, 'data.listId', null)
    if (!id || !listId) return null

    const customData = yield select(customDataSelector, id)

    yield put(
        blockSaveCustomData(MODULE_KEY, id, BLOCK_KEY, {
            ownershipListDetail: _.omit(_.get(customData, 'ownershipListDetail', {}), [listId]),
            ownershipListEstateDetail: _.omit(_.get(customData, 'ownershipListEstateDetail', {}), [listId]),
            ownershipListEstateDetailRow: _.omit(_.get(customData, 'ownershipListEstateDetailRow', {}), [listId]),
        })
    )

    yield put(filterTableRemoveData(createFilterTableId(MODULE_KEY, id, BLOCK_KEY, listId)))

    return null
}

function* onOpenCadastreLink() {
    // TODO process _action for required parameters [#42511]

    const result = yield all({
        response: race({
            success: take(`${OPEN_CADASTRE_LINK_REQUEST}_${SUCCESS}`),
            failed: take(`${OPEN_CADASTRE_LINK_REQUEST}_${FAILED}`),
        }),
        // TODO add required params (action need to be updated) [#42511]
        request: put(openCadastreLinkRequest()),
    })

    if (result.response.failed) {
        error(`${LOCALE_PREFIX}.error.cadastre.url`)
        return null
    }

    const uri = _.get(result.response, 'success.payload.response.body.uri', null)

    if (uri) window.open(uri, '_blank')

    return null
}

export default function* blockTransformSaga() {
    yield all([
        takeEvery(LOAD_REALESTATES_ESTATES_OWNERSHIP_DETAIL_DATA_TABLE, onLoadDataTable),
        takeEvery(REMOVE_REALESTATES_ESTATES_OWNERSHIP_DETAIL_DATA_TABLE, onRemoveDataTable),
        takeEvery(OPEN_CADASTRE_LINK, onOpenCadastreLink),
        ownershipListEstateDetailSaga(),
    ])
}
